import React from 'react'
import AboutSection from '../Components/AboutSection';
import Resume from '../Components/Resume';
import Title from '../Components/Title';
import { MainLayout } from '../Styles/mainLayouts';

const AboutPage = () => {
    return (
        <MainLayout>
            <div>
                {/* <Title title={'About Me'} span={'About Me'} /> */}
                <Title title={'About Me'} />
                <AboutSection />
                <Resume />
            </div>
        </MainLayout>
    )
}

export default AboutPage